import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Login from './pages/Login';
import Landing from './pages/Landing';
import { TermsPage, PrivacyPage } from './pages/Legal';
import Dashboard from './pages/Dashboard';
import Entity from './pages/Entity';
import EntityHistory from './pages/EntityHistory';
import DemandList from './pages/DemandList';
import Help from './pages/Help';
import Purchase from './pages/Purchase';
import AP from './pages/AP';
import AR from './pages/AR';
import Brokers from './pages/Brokers';
import Bank from './pages/Bank';
import Profit from './pages/Profit';
import ChartOfAccounts from './pages/ChartOfAccounts';
import BalanceSheet from './pages/BalanceSheet';
import TrialBalance from './pages/TrialBalance';
import GeneralLedger from './pages/GeneralLedger';
import JournalEntries from './pages/JournalEntries';
import Expenses from './pages/Expenses';
import Income from './pages/Income';
import PurchaseReturns from './pages/PurchaseReturns';
import SalesReturns from './pages/SalesReturns';
import SupplierAdvances from './pages/SupplierAdvances';
import CustomerAdvances from './pages/CustomerAdvances';
import BankReconcile from './pages/BankReconcile';
import Inventory from './pages/Inventory';
import InventoryMerge from './pages/InventoryMerge';
import InventoryActivity from './pages/InventoryActivity';
import ActivityLog from './pages/ActivityLog';
import StockAdjustmentPage from './pages/StockAdjustment';
import StockRevaluationPage from './pages/StockRevaluation';
import StockTransferPage from './pages/StockTransfer';
import OpeningStockPage from './pages/OpeningStock';
import MemoInPage from './pages/MemoIn';
import PurchaseExpensesPage from './pages/PurchaseExpenses';
import SalesExpensesPage from './pages/SalesExpenses';
import Memos from './pages/Memos';
import Sales from './pages/Sales';
import Reminders from './pages/Reminders';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import AdminLogin from './pages/admin/AdminLogin';
import AdminPanel from './pages/admin/AdminPanel';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute page="dashboard">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/demands"
            element={
              <ProtectedRoute page="demand-list">
                <DemandList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/entity"
            element={
              <ProtectedRoute page="entity">
                <Entity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/entity/history"
            element={
              <ProtectedRoute page="entity-history">
                <EntityHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase"
            element={
              <ProtectedRoute page="purchase">
                <Purchase />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/returns"
            element={
              <ProtectedRoute page="purchase-returns">
                <PurchaseReturns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/expenses"
            element={
              <ProtectedRoute page="purchase-expenses">
                <PurchaseExpensesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/expenses"
            element={
              <ProtectedRoute page="sales-expenses">
                <SalesExpensesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/memo-in"
            element={
              <ProtectedRoute page="memo-in">
                <MemoInPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/purchase/advances"
            element={
              <ProtectedRoute page="supplier-advances">
                <SupplierAdvances />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ap"
            element={
              <ProtectedRoute page="ap">
                <AP />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ar"
            element={
              <ProtectedRoute page="ar">
                <AR />
              </ProtectedRoute>
            }
          />
          <Route
            path="/brokers"
            element={
              <ProtectedRoute page="brokers">
                <Brokers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory"
            element={
              <ProtectedRoute page="inventory">
                <Inventory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/merge"
            element={
              <ProtectedRoute page="inventory-merge">
                <InventoryMerge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/transfer"
            element={
              <ProtectedRoute page="stock-transfer">
                <StockTransferPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/adjustment"
            element={
              <ProtectedRoute page="stock-adjustment">
                <StockAdjustmentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/revaluation"
            element={
              <ProtectedRoute page="stock-revaluation">
                <StockRevaluationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/opening"
            element={
              <ProtectedRoute page="opening-stock">
                <OpeningStockPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/activity"
            element={
              <ProtectedRoute page="activity-log">
                <ActivityLog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inventory/activity"
            element={
              <ProtectedRoute page="inventory-activity">
                <InventoryActivity />
              </ProtectedRoute>
            }
          />
          <Route
            path="/memos"
            element={
              <ProtectedRoute page="memos">
                <Memos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales"
            element={
              <ProtectedRoute page="sales">
                <Sales />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/returns"
            element={
              <ProtectedRoute page="sales-returns">
                <SalesReturns />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales/advances"
            element={
              <ProtectedRoute page="customer-advances">
                <CustomerAdvances />
              </ProtectedRoute>
            }
          />
          {/* Help: every login, no page access needed (it hides topics the user can't open). */}
          <Route
            path="/help"
            element={
              <ProtectedRoute>
                <Help />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute page="settings">
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank"
            element={
              <ProtectedRoute page="bank">
                <Bank />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank/reconcile"
            element={
              <ProtectedRoute page="bank-reconcile">
                <BankReconcile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profit"
            element={
              <ProtectedRoute page="profit">
                <Profit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/coa"
            element={
              <ProtectedRoute ownerOnly>
                <ChartOfAccounts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/balance-sheet"
            element={
              <ProtectedRoute page="balance-sheet">
                <BalanceSheet />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/journal"
            element={
              <ProtectedRoute ownerOnly>
                <JournalEntries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/ledger"
            element={
              <ProtectedRoute ownerOnly>
                <GeneralLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/trial-balance"
            element={
              <ProtectedRoute ownerOnly>
                <TrialBalance />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/expenses"
            element={
              <ProtectedRoute page="expenses">
                <Expenses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounting/income"
            element={
              <ProtectedRoute page="income">
                <Income />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reminders"
            element={
              <ProtectedRoute page="reminders">
                <Reminders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute page="reports">
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/panel"
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            }
          />
          <Route path="/" element={<Landing />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
